import React, { useEffect, FunctionComponent, useState } from 'react';
import { Redirect, RouteComponentProps, useParams } from 'react-router-dom';

import { getRole, getToken } from '../../localStorage';
import { acceptRequest } from '../../network/institution';
import { RootState } from '../../redux';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { hydrate } from '../../redux/reducers/session';
import { ROUTES } from '../../routing/routes';
import { types_users } from '../../types/users';

type PropsLocation = {
  location?: RouteComponentProps<{ path: string }, {}, { state: string }>;
};

interface ParamTypes {
  id: any;
}

const RedirectingPageAccept: FunctionComponent<PropsLocation> = props => {
  const params = useParams<ParamTypes>();
  const dispatch = useAppDispatch();
  const id = useAppSelector((state: RootState) => state.session.id);
  const role = getRole();
  const [confirmed, setConfirmed] = useState(false);

  const acceptInvitation = (id: any) => {
    id && acceptRequest(id).then(({}) => setConfirmed(true));
  };

  useEffect(() => {
    acceptInvitation(params.id);
  });

  return (
    <React.Fragment>
      {confirmed && <Redirect to={ROUTES.INSTITUTION} />}
    </React.Fragment>
  );
};

export default RedirectingPageAccept;
